import { gql } from "@apollo/client";

export const exerciseQuery = gql`
    query GetExercise($id: ID!) {
        exercise(id: $id) {
            id
            nameDe
            nameEn
            category
            image
            descriptionDe
            descriptionEn
            equipmentDe
            equipmentEn
            discreet
            recommendationDe
            recommendationEn
            source
        }
    }
`;

export const createExerciseMutation = gql`
    mutation CreateOrder($data: ExerciseCreateInput!) {
        addExercise(data: $data) {
            id
        }
    }
`;

export const updateExerciseMutation = gql`
    mutation UpdateExercise($id: ID!, $data: ExerciseCreateInput!) {
        updateExercise(id: $id, data: $data) {
            id
        }
    }
`;
